import * as types from '../constants/actionTypes';

const initialState = {
  challans: [],
  currentChallan: null,
  poChallans: [],
  deliveryStatus: null,
  deliverySummaries: [],
  statistics: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    total_pages: 0,
  },
  loading: false,
  error: null,
  editingChallan: null,
};

const deliveryChallanReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Delivery Challans
    case types.FETCH_DELIVERY_CHALLANS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_DELIVERY_CHALLANS_SUCCESS:
      return {
        ...state,
        loading: false,
        challans: action.payload.challans || [],
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };

    case types.FETCH_DELIVERY_CHALLANS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Fetch Single Delivery Challan
    case types.FETCH_DELIVERY_CHALLAN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_DELIVERY_CHALLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        currentChallan: action.payload,
        error: null,
      };

    case types.FETCH_DELIVERY_CHALLAN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Create Delivery Challan
    case types.CREATE_DELIVERY_CHALLAN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.CREATE_DELIVERY_CHALLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        challans: [action.payload, ...state.challans],
        error: null,
      };

    case types.CREATE_DELIVERY_CHALLAN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Update Delivery Challan
    case types.UPDATE_DELIVERY_CHALLAN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.UPDATE_DELIVERY_CHALLAN_SUCCESS:
      // The update-status API returns { purchase_order_id, challan_number, delivery_status }
      // — no `id` field. Match by challan_number and patch the status in-place.
      return {
        ...state,
        loading: false,
        challans: state.challans.map((challan) =>
          challan.challan_number === action.payload.challan_number
            ? { ...challan, delivery_status: action.payload.delivery_status }
            : challan
        ),
        currentChallan:
          state.currentChallan?.challan_number === action.payload.challan_number
            ? { ...state.currentChallan, delivery_status: action.payload.delivery_status }
            : state.currentChallan,
        error: null,
      };

    case types.UPDATE_DELIVERY_CHALLAN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Verify Delivery Challan
    case types.VERIFY_DELIVERY_CHALLAN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.VERIFY_DELIVERY_CHALLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        challans: state.challans.map((challan) =>
          challan.id === action.payload.id ? action.payload : challan
        ),
        currentChallan:
          state.currentChallan?.id === action.payload.id
            ? action.payload
            : state.currentChallan,
        error: null,
      };

    case types.VERIFY_DELIVERY_CHALLAN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Delete Delivery Challan
    case types.DELETE_DELIVERY_CHALLAN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.DELETE_DELIVERY_CHALLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        challans: state.challans.filter((challan) => challan.id !== action.payload),
        error: null,
      };

    case types.DELETE_DELIVERY_CHALLAN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Fetch PO Delivery Status
    case types.FETCH_PO_DELIVERY_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_PO_DELIVERY_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        deliveryStatus: action.payload,
        error: null,
      };

    case types.FETCH_PO_DELIVERY_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Fetch Delivery Status Summary
    case types.FETCH_DELIVERY_STATUS_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_DELIVERY_STATUS_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        deliverySummaries: action.payload.summaries || [],
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };

    case types.FETCH_DELIVERY_STATUS_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Fetch Delivery Statistics
    case types.FETCH_DELIVERY_STATISTICS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_DELIVERY_STATISTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        statistics: action.payload,
        error: null,
      };

    case types.FETCH_DELIVERY_STATISTICS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Fetch PO Challans
    case types.FETCH_PO_CHALLANS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_PO_CHALLANS_SUCCESS:
      return {
        ...state,
        loading: false,
        poChallans: action.payload.challans || [],
        error: null,
      };

    case types.FETCH_PO_CHALLANS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // UI State Management
    case types.SET_DELIVERY_CHALLAN_EDITING:
      return {
        ...state,
        editingChallan: action.payload,
      };

    case types.CLEAR_DELIVERY_CHALLAN_EDITING:
      return {
        ...state,
        editingChallan: null,
      };

    default:
      return state;
  }
};

export default deliveryChallanReducer;
